import { AxiosInstance } from 'axios'

import { CardApiFactory } from '../generated/solaris'

export const solarisDefaultApiFactory = (instance: AxiosInstance) => {
  return CardApiFactory(undefined, '', instance)
}
